export const typography = {
  fontFamilies: {
    default: 'inherit',
  },
  fontSizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
    '4xl': '36px',
    '5xl': '48px',
  },
  fontWeights: {
    thin: '100',
    extralight: '200',
    light: '300',
    regular: '400',
    medium: '500',
    demibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900',
  },
  letterSpacings: {
    md: '0.02em',
  },
  lineHeights: {
    xs: '18px',
    sm: '22px',
    md: '24px',
    lg: '26px',
    xl: '30px',
    '2xl': '38px',
    '3xl': '46px',
    '4xl': '60px',
  },
}
